import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// ✅ Import Apollo Client from the configured apolloClient.js
import { ApolloProvider } from "@apollo/client/react";
import { client } from "./apolloClient";

// ✅ Root render
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>
);

// ✅ Optional: Performance tracking
reportWebVitals();
